import React, { useState } from "react";
import axios from 'axios';
import Agendados from "../components/Agendados";
import Navbar from '@/pages/Navbar/Navbar';
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import SolicitacoesPendentes from "../Pages/SolicitacoesPendentes";



export default function Agendamentos() {
  const navigate = useNavigate();
const [form, setForm] = useState({
  nome: "",
  telefone: "",
  rua: "",
  numero: "",
  bairro: "",
  complemento: "",
  cidade: "",
  data: "",
  hora: "",
  observacoes: "",
  valor: "",
});

  const [enviando, setEnviando] = useState(false);
  const [sucesso, setSucesso] = useState(false);
  const [erro, setErro] = useState("");
  const [atualizarLista, setAtualizarLista] = useState(0); // novo estado
  

const handleChange = (e) => {
  const { name, value } = e.target;
  let formattedValue = value;

  if (name === "telefone") {
    const numbers = value.replace(/\D/g, "");
    formattedValue = numbers
      .replace(/^(\d{2})(\d)/g, "($1)$2")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .slice(0, 14);
  } else if (name === "data") {
    formattedValue = value
      .replace(/\D/g, "")
      .replace(/(\d{2})(\d)/, "$1/$2")
      .replace(/(\d{2}\/\d{2})(\d)/, "$1/$2")
      .slice(0, 10);
  } else if (name === "valor") {
    const onlyDigits = value.replace(/\D/g, "");
    const numberValue = (Number(onlyDigits) / 100).toFixed(2);
    formattedValue = `R$ ${numberValue.replace(".", ",")}`;
  } else {
    formattedValue = value.toUpperCase();
  }

  setForm({ ...form, [name]: formattedValue });
};


const handleSubmit = async (e) => {
  e.preventDefault();
  setEnviando(true);
  setErro("");
  setSucesso(false);

  const [day, month, year] = form.data.split("/");
  const formattedData = form.data ? `${year}-${month}-${day}` : form.data;
  

  // Converte "R$ 150,00" para 150.00 (número decimal)
  let valorFinal = null;
  if (form.valor) {
    const valorLimpo = form.valor.replace(/\D/g, ""); // Remove tudo que não é número
    valorFinal = Number(valorLimpo) / 100;
  }

  try {
    const response = await axios.post("/api/public/api/agendamentos", {
      ...form,
      data: formattedData,
      valor: valorFinal, // ⬅️ inclui aqui a conversão
    });

    if (response.data.success) {
      setSucesso(true);
      setAtualizarLista((prev) => prev + 1);

      setForm({
        nome: "",
        telefone: "",
        rua: "",
        numero: "",
        bairro: "",
        complemento: "",
        cidade: "",
        data: "",
        hora: "",
        observacoes: "",
        valor: "",
      });
    }
  } catch (err) {
    setErro("Erro ao agendar. Verifique os dados e tente novamente.");
  } finally {
    setEnviando(false);
  }
};


  return (
    <>
    
    <Navbar />
    
    <div className="flex justify-center mb-8">
  <button
    onClick={() => navigate("/painel")}
    className="flex items-center gap-2 text-yellow-600 hover:text-yellow-800 text-xl font-bold transition duration-300"
  >
    <FaArrowLeft className="text-3xl" />
    <span className="hidden md:inline">Voltar para o Painel</span>
  </button>
</div>
<SolicitacoesPendentes onConcluido={() => setAtualizarLista((prev) => prev + 1)} />

    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      
      <div className="max-w-4xl mx-auto bg-white shadow-2xl rounded-2xl p-8 border border-yellow-200/50 transform hover:shadow-3xl transition-all duration-500">
        <h1 className="text-4xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600 mb-8 text-center">
          📋 Agendamento de Visita
        </h1>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <input
            name="nome"
            value={form.nome}
            onChange={handleChange}
            placeholder="NOME COMPLETO"
            className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl uppercase"
            required
          />
          <input
            name="telefone"
            value={form.telefone}
            onChange={handleChange}
            placeholder="TELEFONE (COM DDD)"
            className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl"
            required
          />
          <input
            name="rua"
            value={form.rua}
            onChange={handleChange}
            placeholder="RUA"
            className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl uppercase"
            required
          />
          <input
            name="numero"
            value={form.numero}
            onChange={handleChange}
            placeholder="NÚMERO"
            className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl uppercase"
            required
          />
          <input
            name="bairro"
            value={form.bairro}
            onChange={handleChange}
            placeholder="BAIRRO"
            className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl uppercase"
            required
          />
          <input
            name="complemento"
            value={form.complemento}
            onChange={handleChange}
            placeholder="COMPLEMENTO"
            className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl uppercase"
          />
          <input
            name="cidade"
            value={form.cidade}
            onChange={handleChange}
            placeholder="CIDADE"
            className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl uppercase"
            required
          />
          <input
            name="data"
            value={form.data}
            onChange={handleChange}
            placeholder="DATA (DD/MM/YYYY)"
            className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl uppercase"
            required
          />
          <input
            type="time"
            name="hora"
            value={form.hora}
            onChange={handleChange}
            placeholder="HORA DO AGENDAMENTO"
            className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl"
            required
          />
          <p className="text-sm text-yellow-600 mt-1 italic">Hora baseada em 24H</p>
          <textarea
  name="observacoes"
  value={form.observacoes}
  onChange={handleChange}
  placeholder="OBSERVAÇÕES (OPCIONAL)"
  rows={3}
  className="md:col-span-2 border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl uppercase"
/>

<input
  name="valor"
  value={form.valor}
  onChange={handleChange}
  placeholder="VALOR (R$)"
  className="border-0 bg-gray-100 text-gray-900 placeholder-gray-400 p-4 rounded-lg w-full focus:ring-2 focus:ring-yellow-400 transition-all duration-300 shadow-lg hover:shadow-xl"
/>


          <div className="md:col-span-2 text-center mt-6">
            <button
              type="submit"
              className="relative bg-gradient-to-r from-yellow-500 to-yellow-600 text-white font-semibold px-8 py-3 rounded-xl shadow-2xl hover:shadow-yellow-500/50 transform hover:-translate-y-1 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={enviando}
            >
              {enviando ? "Enviando..." : "Agendar Visita"}
            </button>
          </div>
        </form>

        {sucesso && (
          <p className="mt-6 text-green-600 font-semibold text-center bg-green-100/50 p-4 rounded-lg shadow-lg animate-fade-in">
            ✅ Agendamento realizado com sucesso!
          </p>
        )}
        {erro && (
          <p className="mt-6 text-red-600 font-semibold text-center bg-red-100/50 p-4 rounded-lg shadow-lg animate-fade-in">
            ❌ {erro}
          </p>
        )}
      </div>

      {/* Atualiza sempre que atualizarLista muda */}
      <Agendados key={atualizarLista} />
    </div>
    </>
  );
}
